import { render, staticRenderFns } from "./image-list.vue?vue&type=template&id=4a0b12b0&scoped=true&"
import script from "./image-list.vue?vue&type=script&lang=js&"
export * from "./image-list.vue?vue&type=script&lang=js&"
import style0 from "./image-list.vue?vue&type=style&index=0&id=4a0b12b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0b12b0",
  null
  
)

export default component.exports